import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EduSitenavigation = class EduSitenavigation extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-sitenavigation';
    }

    constructor(element) {        
        super(element);       
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.DesktopDropdownHover();
        this.plusMinusIconClick();
        this.menuScrollTop();
    }

    setVars() {
        this.$mobileSearchIcon = this.$element.find('.mobile-search-icon .glyphicon-search');
        this.$mobileSearchSpan = this.$element.find('.mobile-search-icon > span');
        this.$navbarForm = this.$element.find('.navbar-form');
        this.$navbarToggle = this.$element.find('.navbar-toggle');
        this.$collapseNavbarCollapse = this.$element.find('.collapse.navbar-collapse');
        this.$desktopDropdown = this.$element.find('.dropdown');
        this.$dropdownToggle = this.$element.find('.dropdown-toggle');
    }

    setEventListeners() {
        this.$mobileSearchIcon.on('click', this.onMobileSearchIconClick.bind(this));
        this.$dropdownToggle.on('blur', this.onPlusMinusIconBlur.bind(this));
        this.$navbarToggle.on('click', this.onNavbarToggleClick.bind(this));
    }

    onMobileSearchIconClick() {
        this.$mobileSearchSpan.toggleClass('glyphicon-remove');
        this.$navbarForm.toggleClass('mobile-search');
        this.$navbarToggle.addClass('collapsed');
        this.$collapseNavbarCollapse.removeClass('in');
        if (!$('.navbar-form').hasClass('mobile-search')) {            
            $('.navbar-form').addClass('search-fixed');
        } else {
            $('.navbar-form').removeClass('search-fixed');
        }
        $('.eduhub-layout .fa-navigation').removeClass('is-mobile-active');
    }

    DesktopDropdownHover() {
        if ($(window).width() > 991 && $('html').hasClass('no-touchevents')) {            
            $(".dropdown").mouseenter(function () {
                $(this).addClass("open");
                $(this).siblings('.dropdown').removeClass('open');               
                $(this).find('span.glyphicon-plus').addClass('glyphicon-minus');
               /* if ($('.dropdown:last-child').hasClass('open')) {                    
                    var screenWidth = $(window).width() - $('.container').width();
                    alert('mov1');
                    if ($('.open.dropdown .dropdown-menu').width() > screenWidth) {
                        alert('move');
                        $('.open.dropdown .dropdown-menu').removeClass('dropdown-menu-left');
                        $('.open.dropdown .dropdown-menu').addClass('dropdown-menu-right');
                    }
                }*/
            }).mouseleave(function () {
                $(this).removeClass("open");
                $(this).siblings('.dropdown').removeClass('open');
                $(this).find('span.glyphicon-plus').removeClass('glyphicon-minus');
            });
        }

        if ($('html').hasClass('touchevents')) {       
            $(".dropdown").on('click', function () {
                var dropdownChild = $(this).children(".dropdown-menu");
                
                if (dropdownChild.is(":visible")) {
                    $(this).removeClass("open");
                    $(this).siblings('.dropdown').removeClass('open');
                    $(this).find('span.glyphicon-plus').removeClass('glyphicon-minus');
                    
                } else {
                    $(this).addClass("open");
                    $(this).siblings('.dropdown').removeClass('open');
                    /*if ($('.dropdown:last-child').hasClass('open')) {
                        alert('test');
                        $('.open.dropdown .dropdown-menu').removeClass('dropdown-menu-left');
                        $('.open.dropdown .dropdown-menu').addClass('dropdown-menu-right');
                    }*/
                    $(this).find('span.glyphicon-plus').addClass('glyphicon-minus');
                }
                

            });

        }
        
    }

    plusMinusIconClick() {
        $('.dropdown-toggle').on('click', function () {           
            $(this).find('span.glyphicon-plus').toggleClass('glyphicon-minus');
        });
    }

    onPlusMinusIconBlur() {
        $('.dropdown-toggle > span.glyphicon-plus').removeClass('glyphicon-minus');
    }

    onNavbarToggleClick() {
        const mobileSearchIcon = $('.mobile-search-icon > span');
        if (mobileSearchIcon.hasClass('glyphicon-remove')) {
            mobileSearchIcon.removeClass('glyphicon-remove');
            $('.navbar-form').addClass('mobile-search');
        }
        
        if ($('.navbar-toggle').is(':visible')) {
            $('.dropdown-toggle').removeClass('disabled');
        }
        $('.eduhub-layout .fa-navigation').toggleClass('is-mobile-active');
        
    }
    menuScrollTop() {
        $(window).on('scroll resize', function () {

            if ($(window).width() > 991) {
                
                if ($(window).scrollTop() > 30) {
                    $('.navbar-fixed-top').addClass('fixed-active');
                } else {
                    $('.navbar-fixed-top').removeClass('fixed-active');
                }
            }
        });
       /* $(window).on('resize', function () {
            if ($('.dropdown:last-child').hasClass('open')) {
                var screenWidth = $(window).width() - $('.container').width();
                if ($('.open.dropdown .dropdown-menu').width() > screenWidth) {
                    alert('resize');
                    $('.open.dropdown .dropdown-menu').removeClass('dropdown-menu-left');
                    $('.open.dropdown .dropdown-menu').addClass('dropdown-menu-right');
                }
            }
        });*/
    }
}




// WEBPACK FOOTER //
// ./components/edu-sitenavigation/scripts/edu-sitenavigation.js